export type LogLevelType = 'debug' | 'info' | 'warn' | 'error';

export interface ILogContext {
    [key: string]: any;
}

export interface ILogTransport {
    log(level: LogLevelType, message: string, context?: ILogContext): void;
}

export interface ILogger {
    debug(message: string, context?: ILogContext): void;
    info(message: string, context?: ILogContext): void;
    warn(message: string, context?: ILogContext): void;
    error(message: string, context?: ILogContext): void;
}

export class Logger implements ILogger {
    private transports: ILogTransport[] = [];
    addTransport(transport: ILogTransport) {
        this.transports.push(transport);

        return this;
    }

    private log(level: LogLevelType, message: string, context?: ILogContext) {
        this.transports.forEach((transport) => {
            try {
                transport.log(level, message, context);
            } catch (error) {
                console.error('Logger transport failed:', error);
            }
        });
    }

    debug(message: string, context?: ILogContext) {
        this.log('debug', message, context);
    }

    info(message: string, context?: ILogContext) {
        this.log('info', message, context);
    }

    warn(message: string, context?: ILogContext) {
        this.log('warn', message, context);
    }

    error(message: string, context?: ILogContext) {
        this.log('error', message, context);
    }
}

export const logger = new Logger();
